// Assignment-level diff between saved performances and schedule entries.
//
// A "signature" captures only the assignment fields that define what work was
// planned: project_part_id + time_slice NAME + work_type_id + tool_id. The slice
// is compared by name (day/morning/afternoon) rather than id, because each
// attendance rule owns its own slice ids — a performance normalized to the
// attendance's rule and a schedule entry on a different rule still describe the
// same 区分. Derived values (time spans, man-days) follow from the slice, so they
// are not part of the signature.
//
// The two sides are compared as multisets so that adding, removing, or changing
// any row flips the result.

export function performanceSignaturesFromDom(container) {
  if (!container) return []
  const signatures = []
  container.querySelectorAll(".work-item-container").forEach(row => {
    if (isRowDropped(row)) return
    signatures.push(signatureFromDataset(row.dataset))
  })
  return signatures
}

export function scheduleSignatures(entries) {
  return (entries || []).map(entry =>
    buildSignature(entry.project_part_id, entry.time_slice?.name, entry.work_type_id, entry.tool_id)
  )
}

export function signaturesDiffer(a, b) {
  if (a.length !== b.length) return true
  const sortedA = [...a].sort()
  const sortedB = [...b].sort()
  return sortedA.some((value, index) => value !== sortedB[index])
}

function isRowDropped(row) {
  if (row.style.display === "none") return true
  const destroy = row.querySelector('input[name$="[_destroy]"]')
  return Boolean(destroy && destroy.value === "true")
}

function signatureFromDataset(dataset) {
  return buildSignature(
    dataset.originalProjectPartId,
    dataset.originalTimeSliceName,
    dataset.originalWorkTypeId,
    dataset.originalToolId
  )
}

function buildSignature(projectPartId, timeSliceName, workTypeId, toolId) {
  return [norm(projectPartId), norm(timeSliceName), norm(workTypeId), norm(toolId)].join("|")
}

function norm(value) {
  return value == null || value === "" ? "" : String(value)
}
